import { useEffect, useRef, useState } from 'react';

import { selectAuthSession, selectIsProvisionalAccount } from '../auth/store/selectors';
import { selectUniversityData } from '../db/courses/selectors';
import { AcadlyPage } from '../db/shared/types';
import { usePageManager } from '../pages/hooks';
import { useAppSelector } from '../store/hooks';
import { selectHomeActiveTab } from './store/selectors';

const useHome = () => {
  const { isPageReady } = usePageManager(AcadlyPage.HOME, { setPageReadyWhenParentIsReady: true });

  const session = useAppSelector((state) => selectAuthSession(state))!;
  const isProvisionalAccount = useAppSelector((state) => selectIsProvisionalAccount(state));

  /** scroll to top on change of active tab */

  const courseListWrapperRef = useRef<HTMLDivElement>(null);
  const activeTab = useAppSelector((state) => selectHomeActiveTab(state));

  useEffect(
    function onTabChange() {
      courseListWrapperRef.current?.scrollIntoView({ block: 'start' });
    },
    [activeTab]
  );

  /** Create course drawer */
  const [selectedCourseId, setSelectedCourseId] = useState<MongoId>();
  const [isCreateCourseDrawerOpen, setIsCreateCourseDrawerOpen] = useState(false);

  const handleCloseCreateCourseDrawer = () => {
    setSelectedCourseId(undefined);
    setIsCreateCourseDrawerOpen(false);
  };

  /** Information alert that opens before create course drawer */

  const [isInformationAlertOpen, setIsInformationAlertOpen] = useState(false);

  const handleCloseInformationAlert = () => {
    setIsInformationAlertOpen(false);
  };

  const handleContinueInformationAlert = () => {
    setIsInformationAlertOpen(false);
    setIsCreateCourseDrawerOpen(true);
  };

  /** Join existing course drawer */

  const [isJoinAnExistingCourseDrawerOpen, setIsJoinAnExistingCourseDrawerOpen] = useState(false);

  const handleCloseJoinAnExistingCourseDrawer = () => {
    setIsJoinAnExistingCourseDrawerOpen(false);
  };

  /** fab menu and course creation */
  const universityData = useAppSelector((state) => selectUniversityData(state));

  const handleClickCreateCourse = () => {
    if (universityData?.hasEnterpriseAccount && universityData.integratedWith) {
      setIsInformationAlertOpen(true);
    } else {
      setIsCreateCourseDrawerOpen(true);
    }
  };

  const handleClickJoinAnExistingCourse = () => {
    setIsJoinAnExistingCourseDrawerOpen(true);
  };

  /** course widget */
  const [isCreatingProCourse, setIsCreatingProCourse] = useState(false);

  const handleClickUnpublishedCourse = (courseId: MongoId, isCreatingProCourse: boolean) => {
    setSelectedCourseId(courseId);
    setIsCreatingProCourse(isCreatingProCourse);
    setIsCreateCourseDrawerOpen(true);
  };

  return {
    session,
    isProvisionalAccount,
    isFetchingCourses: !isPageReady,
    courseListWrapperRef,
    handleClickUnpublishedCourse,
    handleClickCreateCourse,
    handleClickJoinAnExistingCourse,
    isInformationAlertOpen,
    handleCloseInformationAlert,
    handleContinueInformationAlert,
    isCreateCourseDrawerOpen,
    handleCloseCreateCourseDrawer,
    selectedCourseId,
    isCreatingProCourse,
    isJoinAnExistingCourseDrawerOpen,
    handleCloseJoinAnExistingCourseDrawer,
  };
};

export default useHome;
